export enum ComplianceDocumentTypeEnum {
    SignedContract = 41,
    BackgroundCheck = 45,
    Housing = 50
}
